import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { CostTableDataService } from "./cost-table-data.service";
import { LabelModule } from "libraries/service/label/label.module";
import { TableDataModule } from "app_quotation/shared/services/table-data/table-data.module";

@NgModule({
 imports: [
     CommonModule,
     LabelModule,
     TableDataModule,
 ],
 exports: [],
 declarations: [],
 providers: [
     CostTableDataService
 ],
})
export class CostTableDataModule { }
